<template>
    <v-card :color="color" class="rounded-0" dark flat>
        <v-container class="pa-0">
            <v-row no-gutters justify="space-between" align="center">
                <v-spacer></v-spacer>
                <v-col cols="auto" class="d-flex align-center pa-2 pb-0">
                    <DatePicker v-model="date" type="date" align="right" :format="dateformat" start-placeholder="Date"
                        :placeholder="dateformat.toLowerCase()" size="small" :picker-options="{ firstDayOfWeek: 1 }"
                        :clearable="false" class="headerTimeSelect ml-3" :disabled="disabled"
                        style="width: 150px !important; font-size: 16px;">
                    </DatePicker>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
            <v-row no-gutters justify="space-between" align="center">
                <v-col cols="auto" class="d-flex flex-column align-center py-2 ">
                    <h5 v-text="$t('servicesystem.common_objects.commonterms.start')" />
                    <TimeSelect v-model="startTime" :format="timefomat" :picker-options="{
                        start: '00:00',
                        end: '23:45',
                        step: '00:15'
                    }" placeholder="00:00" prefix-icon=" " class="headerTimeSelect" :disabled="disabled">
                    </TimeSelect>
                </v-col>
                <v-col cols="auto" class="d-flex flex-column align-center py-2 ">
                    <h3 v-text="$t('servicesystem.common_objects.commonterms.duration')" />
                    <TimeSelect v-model="duration" :format="timefomat" :picker-options="{
                        start: '00:00',
                        end: '24:00',
                        step: '00:15'
                    }" prefix-icon=" " class="headerTimeSelect" :clearable="false" :disabled="disabled"
                        style="width: 135px !important; font-size: 28px;">
                    </TimeSelect>
                </v-col>
                <v-col cols="auto" class="d-flex flex-column align-center py-2 ">
                    <h5 v-text="$t('servicesystem.common_objects.commonterms.end')" />
                    <TimeSelect v-model="stopTime" :format="timefomat" :picker-options="{
                        start: '00:00',
                        end: '23:45',
                        step: '00:15',
                        minTime: startTime
                    }" placeholder="00:00" prefix-icon=" " class="headerTimeSelect" :disabled="disabled">
                    </TimeSelect>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>


<script>
import { DatePicker, TimeSelect } from 'element-ui';
import moment from "moment";
import Vue from "vue";

export default {
    name: "TimeDurationEditor",
    model: {
        prop: "item",
        event: "change",
    },
    props: {
        item: Object,
        color: {
            type: String,
            default: 'primary',
        },
        disabled: Boolean,
    },
    components: {
        DatePicker,
        //InputNumber,
        TimeSelect,
    },
    mixins: [],

    data() {
        return {
            valid: false,
            editObject: {},
        };
    },

    mounted() {
        this.parseItem(this.item);
    },

    methods: {
        parseItem(item) {
            this.editObject = Object.assign({}, item);
            console.log("timeControls parse", this.editObject.AdjustCount);
        },

        addZonedTimeStringToUtcDateTimeString(dateString, timeString) {
            let tempDate = moment(dateString);
            if (timeString) {
                tempDate.set({
                    'hour': parseInt(timeString.split(':')[0]),
                    'minute': parseInt(timeString.split(':')[1])
                });
            }
            else {
                tempDate.set({
                    'hour': 0,
                    'minute': 0
                });
            }
            return tempDate.utc().toISOString();
        },

        adjustEndTime() {
            if (this.editObject.Start && this.editObject.Duration) {
                const startTime = moment(this.editObject.Start);
                const endTime = startTime.clone().add(this.editObject.Duration, 'hours');
                var string = endTime.utc().toISOString();
                Vue.set(this.editObject, 'End', string);
            }
        },

        adjustStartEndDates(date) {
            var start = this.addZonedTimeStringToUtcDateTimeString(date, this.startTime);
            var end = this.addZonedTimeStringToUtcDateTimeString(date, this.stopTime);
            Vue.set(this.editObject, 'Start', start);
            Vue.set(this.editObject, 'End', end);
        },

        emit() {
            if (this.editObject.AdjustCount) {
                this.editObject.Count = this.editObject.Duration;
            }
            const payload = Object.assign({}, this.editObject);
            this.$emit('change', payload);
        },

        //used to set date to today in cases where no emplyment date was set but
        setInitialDate() {
            if (!this.date) {
                var today = moment().utc().toISOString();
                Vue.set(this.editObject, 'Date', today);
                this.adjustStartEndDates(today);
                if (!this.editObject.Duration) {
                    Vue.set(this.editObject, 'Duration', this.item.Count);
                }
            }
        }
    },

    computed: {
        date: {
            get() {
                return this.editObject.Date;
            },
            set(value) {
                Vue.set(this.editObject, 'Date', value);
                this.adjustStartEndDates(value);
                this.emit();
            }
        },

        startTime: {
            get() {
                return this.i18nFormatTime(this.editObject.Start);
            },
            set(value) {
                //catch to make sure date is set first before time controls kick in.
                if (!this.date) {
                    this.setInitialDate();
                }

                var string = this.addZonedTimeStringToUtcDateTimeString(this.editObject.Start, value);
                Vue.set(this.editObject, 'Start', string);
                console.log('start', string)

                this.adjustEndTime();
                this.emit();
            },
        },

        duration: {
            get() {
                //return double as time string
                const count = this.editObject.Duration || 0;
                const hours = Math.floor(count).toString().padStart(2, '0');
                const minutes = Math.round((count - Math.floor(count)) * 60).toString().padStart(2, '0');
                return `${hours}:${minutes}`;
            },
            set(value) {
                if (!value) {
                    this.editObject.Duration = 0;
                }
                else {
                    //catch to make sure date is set first before time controls kick in.
                    if (!this.date) {
                        this.setInitialDate();
                    }
                    // Split and convert the duration
                    const [hours, minutes] = value.split(':').map(Number);
                    var doubleHours = hours + minutes / 60;
                    Vue.set(this.editObject, 'Duration', doubleHours);

                    this.adjustEndTime();
                    this.emit();
                }
            },
        },

        stopTime: {
            get() {
                return this.i18nFormatTime(this.editObject.End);
            },
            set(value) {
                //catch to make sure date is set first before time controls kick in.
                if (!this.date) {
                    this.setInitialDate();
                }

                var string = this.addZonedTimeStringToUtcDateTimeString(this.editObject.End, value);
                const startTime = moment(this.editObject.Start);
                const endTime = moment(string);
                const duration = moment.duration(endTime.diff(startTime));
                this.editObject.Duration = duration.asHours();

                Vue.set(this.editObject, 'End', string);
                this.emit();
            },
        },

        dateformat() {
            return this.$t('servicesystem.formatting.dateformat').replace('YYYY', 'yyyy').replace('DD', 'dd');
        },
        timefomat() {
            return this.$t('servicesystem.formatting.timeformat');
        },
    },

    watch: {
        item: {
            handler(newValue) {
                this.parseItem(newValue);
                //this.adjustEndTime();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.headerTimeSelect {
    width: 115px !important;
    font-size: 21px;
}

.headerTimeSelect input {
    color: white;
    background: none !important;
    border: none !important;
}
</style>